// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"c6db517b","453":"44772e86"}[chunkId] + ".chunk.js";
};